export const IDENTITY_LOGIN =`${process.env.NX_PUBLIC_IDENTITY_HOST}/oauth2/authorize?scope=${process.env.NX_PUBLIC_IDENTITY_SCOPE}:*&redirect_uri=${process.env.NX_PUBLIC_HOST}/&response_type=token&client_id=${process.env.NX_PUBLIC_IDENTITY_CLIENT_ID}`;
export const IDENTITY_LOGOUT = `${process.env.NX_PUBLIC_IDENTITY_HOST}/signout?redirect_uri=${process.env.NX_PUBLIC_HOST}`;
export const IDENTITY_AUTHORIZE =`${process.env.NX_PUBLIC_IDENTITY_HOST}/oauth2/authorize?scope=${process.env.NX_PUBLIC_IDENTITY_SCOPE}:*&redirect_uri=${process.env.NX_PUBLIC_HOST}/&response_type=token&client_id=${process.env.NX_PUBLIC_IDENTITY_CLIENT_ID}`;

export const getCustomRedirectIdentityLoginUrl = (redirectTo = process.env.NX_PUBLIC_HOST, overrides = {}) => {
  const host = overrides.host ?? process.env.NX_PUBLIC_IDENTITY_HOST;
  const clientId = overrides.clientId ?? process.env.NX_PUBLIC_IDENTITY_CLIENT_ID;

  // `scopeRaw` is the already URL-formatted scope, used verbatim (e.g. multi-scope
  // "sb:*+idu:*+orca:*"). Without it we keep the original single-scope behavior:
  // a bare scope name with ":*" appended, emitted unencoded (portal/pay/cash/you
  // path, byte-for-byte identical to before).
  const scope = overrides.scopeRaw
    ? overrides.scopeRaw
    : `${overrides.scope ?? process.env.NX_PUBLIC_IDENTITY_SCOPE}:*`;

  // `tenant_id` is only emitted when an override provides it (sandbox). The default
  // portal/pay/cash/you flow never sets it, so its URL stays byte-for-byte identical.
  const tenantParam = overrides.tenantId
    ? `&tenant_id=${overrides.tenantId}`
    : '';

  return `${host}/oauth2/authorize?scope=${scope}${tenantParam}&redirect_uri=${encodeURIComponent(redirectTo)}&response_type=token&client_id=${clientId}`;
};
